module.exports = __webpack_public_path__ + "img/pic_zhuangshi.296b5141.png";